module.exports = __webpack_public_path__ + "static/media/sign-out.63a9ded0.svg";